import { render, staticRenderFns } from "./ShippingDestinyTransportationForm.vue?vue&type=template&id=4204ff4d"
import script from "./ShippingDestinyTransportationForm.vue?vue&type=script&lang=js"
export * from "./ShippingDestinyTransportationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports